import React from 'react'
import '../Project.css';
import { Parallax } from 'react-parallax';
import Image1 from '../../Gemco-Website-Images/projects/C3_Airport.webp';

const Project_Three = () => {

  return (
    <>

      <div className='project_1_work' id="workBanner">

        <div className="container project_our_work">

          <div className="heading">
            <h1>Dubai International Airport — Concourse 3 & 4</h1>
          </div>

          <hr></hr>
          <div className='project_section'>
            <div className="project_section_content">
              <h1 className="project_scope">Scope of Work</h1>
              <p>Major expansion works across Concourse 3 and Concourse 4 at Dubai International Airport — one of the world's busiest
                  aviation hubs. Concourse 3 is the dedicated home of Emirates A380 operations. Consultant: Dar Al Handasah.</p>
              <p>MAIN CONTRACTOR : C3: ALEC | C4: DBB</p>
              <p>MEP CONTRACTOR : ETA</p>
              <p>GEMCO SCOPE OF WORKS : Main central plant room and multiple secondary plant
                rooms across the hospital complex</p>
              {/* <h2 className="project_years">2014 – 2022</h2> */}
            </div>
            <div className='project_1_card'>
              <img className="project_one_image" width="500" height="300" src={Image1} alt="Project" />
            </div>
          </div>
        </div>
      </div>

    </>

  )
}

export default Project_Three